<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.companyPaidInvoices')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoiceNumber')}}</label>
                                    <input type="text" v-model="search.number" @keyup="searchInvoice"
                                        class="form-control">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoiceDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="search.invoiceDate" valueType="format"
                                        :format="dateFormat" @change="searchInvoice"
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                    </date-picker>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.amount')}}</label>
                                    <input type="text" v-model="search.amount" @keyup="searchInvoice"
                                        class="form-control">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.company')}}</label>
                                    <input type="text" v-model="search.company" @keyup="searchInvoice"
                                        class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoicePurpose')}}</label>
                                    <input type="text" v-model="search.invoicePurpose" @keyup="searchInvoice"
                                        class="form-control">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.currency')}}</label>
                                    <v-select @input="searchInvoice" :options="currencies" v-model="search.currency"
                                        :reduce="currencies => currencies"></v-select>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.paymentDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="search.paymentDate" valueType="format"
                                        :format="dateFormat" @change="searchInvoice"
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                    </date-picker>
                                </div>
                            </div>
                            <div class="col-12">
                                <hr>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.book.presetName')">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.companyPaidInvoices')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="invoices.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.invoice.number')}}</th>
                                    <th>{{$t('form.invoice.status')}}</th>
                                    <th>{{$t('form.invoice.date')}}</th>
                                    <th>{{$t('form.invoice.amount')}}</th>
                                    <th>{{$t('form.invoice.invoicePurpose')}}</th>
                                    <th>{{$t('form.invoice.company')}}</th>
                                    <!-- <th>{{$t('form.invoice.paid')}}</th> -->
                                    <th class="text-right">{{$t('form.invoice.viewInvoice')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(invoice, index) in invoices" v-bind:key="index">
                                <tr>
                                    <td>{{invoice.InvoiceNumber}}</td>
                                    
                                    <td v-if="invoice.Status==1">{{$t('form.invoice.status_pending')}}</td>
                                    <td v-else-if="invoice.Status==2">{{$t('form.invoice.status_approved')}}</td>
                                    <td v-else-if="invoice.Status==3">{{$t('form.invoice.status_sent')}}</td>
                                    <td v-else-if="invoice.Status==4">{{$t('form.invoice.status_paid')}}</td>
                                    <td v-else-if="invoice.Status==null ||invoice.Status==undefined ||invoice.Status==0"></td>

                                    <td>{{invoice.InvoiceDate | formatDate(dateFormat)}}</td>
                                    <td>{{invoice.Currency}}
                                        {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                    </td>
                                    <td>{{invoice.InvoicePurpose}}</td>
                                    <td>{{invoice.CompanyName}}</td>
                                    <!-- <td>{{invoice.Paid == -1 ? 'Yes' : 'No'}}</td> -->
                                    <td class="text-right">
                                        <button class="btn btn-dark btn-sm" @click="goToShow(index)"
                                            v-if="permissions.viewInvoicesCompanies">
                                            <i class="fa fa-print"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['permissions', 'dateFormat', 'decimalDigits', 'decimalPoint', 'thousandSeparator'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                detailedSearch: false,
                presetSelected: false,

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                pagination: {
                    current_page: 1
                },

                search: {
                    paid: '',
                    currency: ''
                },

                preset: {
                    name: '',
                    entity: 'companyPaidInvoice',
                    value: {}
                },

                currencies: [],
                presetList: [],
                invoices: []
            }
        },

        async mounted() {
            this.isLoading = true;
            if (!this.permissions.viewInvoicesCompaniesPaid) {
                return this.$router.push('/');
            }

            await this.getCurrencies();

            if (localStorage.getItem('filter-cinvoice-paid')) {
                this.search = JSON.parse(localStorage.getItem('filter-cinvoice-paid'));
            }

            this.getInvoices();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-cinvoice-paid', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {
            getDate(date){
                var dateVar  = date?moment(date).format(this.dateFormat):moment().format(this.dateFormat)
                return dateVar;
            },
            async getCurrencies() {
                await axios
                    .get('/api/currencies')
                    .then(response => this.currencies = response.data);
            },

            getInvoices() {

                this.isLoading = true;

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios.get('/api/getCompanyPaidInvoiceList?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.isLoading = false;
                        this.invoices = response.data.data.data;
                        this.pagination = response.data.pagination;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    });
            },

            paginate() {
                this.getInvoices();
            },

            searchInvoice() {
                this.pagination.current_page = 1;
                this.getInvoices();
            },

            // Clear search input fields
            clearSearch() {
                this.search = {
                    paid: '',
                    currency: ''
                };

                this.searchInvoice();
            },

            goToShow(index) {
                let id = this.invoices[index].ID;

                this.$router.push({
                    name: "InvoiceShow",

                    params: {
                        id: id
                    }
                });
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message, 'success');
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria 
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: 'companyPaidInvoice'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchInvoice();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message, 'success');
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
